import logoSlider from '../../../blocks/logo-slider/scripts/logo-slider';
import { infoService } from '../../../blocks/intro-service/scripts/intro-service';

export default function () {
  logoSlider();
  infoService();
}
